<template>
  <div class="distributionDetail">
    <!-- <heads></heads> -->
    <div class="container">
         <div class="title">{{title}}</div>
      <div class="content">
        <div class="left">
          <img :src="message.picture.linePicture" alt class="del-img" />
        </div>
        <div class="right">
            <div class="item">
                <i class="fa fa-file-text-o" aria-hidden="true"></i>
                <span class="text">订单号：{{message.orderSale.sn}}</span> 
            </div>
            <div class="item">
                <i class="fa fa-file-text-o" aria-hidden="true"></i>
                <span class="text">订单状态：<span class="col">{{parseInt(message.orderSale.orderStatus) ? '已确认' : '未确认'}}</span></span> 
            </div>
            <div class="item">
                <i class="fa fa-clock-o" aria-hidden="true"></i>
                <span class="text">订单时间：{{fomateDate(message.orderSale.createDate)}}</span> 
            </div>
            <div class="item">
                <i class="fa fa-file-text-o" aria-hidden="true"></i>
                <span class="text">付款金额：￥{{message.orderSale.orderTotalSum}}</span> 
            </div>
               <div class="item">
                <i class="fa fa-file-text-o" aria-hidden="true"></i>
                <span class="text">佣金比例：{{ parseFloat(message.orderSale.salesProportion) * 100 }}%</span> 
            </div>
               <div class="item">
               <i class="fa fa-database" aria-hidden="true"></i>
                <span class="text">佣金金额：<span class="col-red">￥{{message.orderSale.money}}</span></span> 
            </div>
            <!-- <div class="item">
              <i class="fa fa-files-o" aria-hidden="true"></i>
                <span class="text">支付方式：微信支付</span> 
            </div> -->
        </div>
      </div>
    </div>
    <!-- <homeFoots></homeFoots> -->
  </div>
</template>

<script>
import heads from "@/components/comment/heads.vue";
import homeFoots from "@/components/comment/homeFoots.vue";
import banners from "@/components/comment/banners.vue";

import axios from "axios";
import qs from "qs";

import {fomateDate} from "@/util/util.js";

export default {
  name: "distributionDetail",
  data() {
    return {
      pageNumber: 1,
      total: 0,
      nav: 0,
      navArray: ["TA的活动", "个人介绍"],
      // id: null
      message:{}
    };
  },
  components: {
    heads,
    homeFoots,
    banners
  },
  computed: {
    title(){
      try{
        return this.message.orderSale.lineOrder.lineSchedule.line.lineTitile
      }catch(e){}
    }
  },
  methods: {
    fomateDate,

    getNav(index) {
      this.nav = index;
    },
    getDistributionDetail(id){
      axios.get('/mobile/wallet/shareDetails.jhtml',{
        params:{
          orderSaleId:id
        }
      }).then(res => {
        if(res.data.success){
          this.message = res.data.output;
        }
      })
    }
  },
  mounted() {},
  created() {
    // this.id =  this.$route.params.id;
    this.getDistributionDetail(this.$route.query.id);
  }
};
</script>

<style scoped>
.activityIndex {
  width: 100%;
  height: 100%;
}
.container {
  text-align: left;
  margin-bottom: 60px;
}
.content {
    display: flex;
    justify-content: space-between;
  width: 100%;
}
.left {
  width: 48%;
}
.right{
    width: 48%;
}
.title {
  font-weight: bold;
  margin: 20px 0;
}
.del-img {
  width: 100%;
  height: 400px;
}
.item{
display: flex;
align-items: center;
color: #323232;
margin-bottom: 42px;
}
.col{
    color: #5dba45;
}
.item:last-child{
    margin-bottom: 0px;
}
.text{
    display: block;
    margin-left: 20px;
}
.col-red{
      color: #e73835;
}
</style>



// WEBPACK FOOTER //
// src/components/userview/distributionDetail.vue